import { ShowButton, TextField, useTable,
         EditButton, DeleteButton 
    } from "@refinedev/antd";
import { useUpdate } from "@refinedev/core";
import { List, Table, Space, Popover, Form, Input, Select, Typography, notification, Button, Spin, Card } from "antd";
import { format, formatDistanceToNow } from 'date-fns';

import { useCustom } from "@refinedev/core";
import { TOKEN_KEY } from "../../../authProvider";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { debounce } from "lodash";
import UserSearchSelect from "../../components/UserSearchSelect";
import { FilterOutlined } from "@ant-design/icons";

const { Title } = Typography;

export function SubscribersList() {
    const { Title } = Typography;
    const navigate = useNavigate();
    const [ hoveredRow, setHoveredRow ] = useState<string>();
    const [searchForm] = Form.useForm();


    const handleMouseEnter = (id: string) => {
      setHoveredRow(id);
    }

    const handleMouseLeave = () => {
      setHoveredRow("");
    };

    const { tableProps, searchFormProps } = useTable({
      resource: "subscription",
      syncWithLocation: true,
      queryOptions: {
        keepPreviousData: false,
        cacheTime: 20,
      },
      onSearch: (values: any) => {
        // console.log("Search values:", values);
        return [
          {
            field: "q",
            operator: "contains",
            value: values.q,
          },
          {
            field: "subscriberID",
            operator: "eq",
            value: values.subscriberID ? values.subscriberID : undefined,
          },
          {
            field: "coachName",
            operator: "eq",
            value: values.coachName ? values.coachName : undefined,
          },
        ]
      }
    });
  
    const subscriptionColumns = [
      {
        title: 'Subscriber email',
        dataIndex: 'subscriberEmail',
        render: (value: string, record: any) => (
          <TextField
            value={value}
            onClick={() => {
              navigate(`/users/${record.subscriberID}`);
            }}
            style={{
                cursor: 'pointer',
                textDecoration: 'none'
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.textDecoration = 'underline';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.textDecoration = 'none';
            }}
          />
        )
      },
      {
        title: 'Subscriber name',
        dataIndex: 'subscriberName',
        render: (value: string, record: any) => (
          <TextField
            value={value}
            onClick={() => {
              navigate(`/users/${record.subscriberID}`);
            }}
            style={{
                cursor: 'pointer',
                textDecoration: 'none'
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.textDecoration = 'underline';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.textDecoration = 'none';
            }}
          />
        )
      },
      {
        title: 'Created at',
        dataIndex: 'createdAt',
        render: (value: any) => (
          <Popover content={format(value, "MM/dd/yy hh:mm a")}>
            <span>{formatDistanceToNow(value)} ago</span>
          </Popover>
        )
      },
      {
        title: 'Status',
        dataIndex: 'status',
        width: 100,
        render: (value: string) => (
          <Space style={{
            color: value === "ACTIVE" ? "green" : "red"
          }}>
            <TextField value={value} />
          </Space>
        ),
      },
      {
        title: 'Start date',
        dataIndex: 'startDate',
        render: (value: any) => (
          <Popover content={format(value, "MM/dd/yy hh:mm a")}>
            <span>{formatDistanceToNow(value)} ago</span>
          </Popover>
        )
      },
      {
        title: 'End date',
        dataIndex: 'endDate',
        render: (value: any) => (
          <Popover content={format(value, "MM/dd/yy hh:mm a")}>
            <span>{formatDistanceToNow(value)} ago</span>
          </Popover>
        )
      },
      {
        title: 'Actions',
        dataIndex: 'actions',
        render: (_: any, record: any) => (
          <ShowButton hideText size="small" recordItemId={record?.id} />
        )
      } 
    ];
  
    // console.log('Subscriptions: ', tableProps.dataSource)
    return (
      <div style={{ padding: "4px", position: "relative", }}>
        <div style={{
          display: "flex",
          alignItems: "start",
          gap: 24,
        }}>
          <Card style={{ width: 300 }}>
            <Title level={3}>Filter Subscriptions</Title>
            <hr style={{
              marginLeft: -25,
              border: "0.2px solid #424242",
              width: 300,
            }} />
            <Form 
              {...searchFormProps}
              layout="vertical"
              style={{ marginTop: 20 }}
            >
              <Form.Item name="q" label="Search">
                <Input
                  placeholder="Search by email or name" 
                  allowClear />
              </Form.Item>
              <Form.Item name="subscriberID" label="Subscriber">
                <UserSearchSelect
                  userType={["USER"]}
                  onChange={(value) => searchForm.setFieldValue("subscriberID", value)}
                />
              </Form.Item>
              <Form.Item name="coachName" label="Coach Name">
                <Input placeholder="Search by coach name" allowClear />
              </Form.Item>
              <Space style={{ display: "flex", justifyContent: "flex-end" }}>
                <Form.Item>
                  <Button
                    type="primary"
                    icon={<FilterOutlined />}
                    htmlType="submit"
                  >
                    Search
                  </Button>
                </Form.Item>
              </Space>
            </Form>
          </Card>
  
          <div style={{ flex: 1 }}>
            <Title level={4}>Subscriptions</Title>
            <List>
              <Table
                {...tableProps}
                columns={subscriptionColumns}
                rowKey="id"
                pagination={{
                  ...tableProps.pagination,
                  showTotal: (total) => `Total ${total} items`,
                  showSizeChanger: true,
                  showQuickJumper: true,
                }}
              />
            </List>
          </div>
        </div>
      </div>
    );
  }